import { TranslocoService } from '@ngneat/transloco';

import { OverlayContainer } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatStepperModule } from '@angular/material/stepper';

import { SnAbilityModule } from '@lib/ability';
import { SnFormModule } from '@lib/form';
import { SnFormRadioModule } from '@lib/form/radio';
import { TranslationModule, AVAILABLE_LANGUAGES } from '@lib/translation';
import { SnIconModule } from '@lib/ui/icon';
import { ExistingFullscreenOverlayContainer } from '@lib/ui/overlay';

import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    TranslationModule.forRoot({
      availableLangs: AVAILABLE_LANGUAGES,
      defaultLang: 'en-US',
      fallbackLang: 'en-US',
      reRenderOnLangChange: true,
      prodMode: environment.production,
      logMissingKey: false,
    }),
    AppRoutingModule,
    SnFormModule,
    SnFormRadioModule,
    FormsModule,
    MatStepperModule,
    MatProgressBarModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    SnIconModule,
    MatDialogModule,
    SnAbilityModule.forRoot(),
  ],
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  providers: [
    { provide: OverlayContainer, useClass: ExistingFullscreenOverlayContainer },
    {
      provide: APP_INITIALIZER,
      useFactory: (transloco: TranslocoService) => {
        return () => {
          return transloco.load('en-US').toPromise();
        };
      },
      deps: [TranslocoService],
      multi: true,
    },
  ],
})
export class AppModule {}
